/**
 * Direktlink in die Brevo-Oberfläche. Er ist der Notausgang, falls der Abgleich
 * zwischen Mailtool und Brevo hakt: Das Team öffnet damit genau die Kampagne,
 * die zur Mail gehört, statt sie in der Brevo-Liste zu suchen.
 *
 * Die Adresse steht nur hier — ändert Brevo seine Oberfläche, genügt eine Stelle.
 */
const BREVO_APP = 'https://app.brevo.com';

/** Mailtool-Stände, in denen die Kampagne in Brevo schon verschickt ist (dort gibt es den Bericht statt des Editors). */
const VERSENDET = ['sent', 'sending'];

/**
 * Adresse der Kampagne in Brevo; `null`, wenn es dort (noch) keine gibt.
 * Offene Kampagnen (Entwurf, eingeplant, angehalten) öffnen im Editor,
 * versendete im Bericht.
 */
export function brevoKampagneUrl(
  brevoId: number | string | null | undefined,
  mailStatus?: string | null,
  brevoStatus?: string | null,
): string | null {
  if (brevoId === null || brevoId === undefined || brevoId === '') return null;
  const id = encodeURIComponent(String(brevoId));
  const versendet = (mailStatus != null && VERSENDET.includes(mailStatus)) || brevoStatus === 'sent' || brevoStatus === 'in_process';
  return versendet
    ? `${BREVO_APP}/marketing-reports/email/${id}/overview`
    : `${BREVO_APP}/marketing-campaign/edit/${id}`;
}
